import React from "react";
import LegalPage from "@/pages/LegalPage";

export default function TermsPage() {
  return <LegalPage nsKey="terms" testid="terms-page" sectionCount={9} />;
}
